module.exports = __webpack_public_path__ + "img/c07_unitstartechdrinkofaegir_Normal_ua.2780f80c.webp";